<button
    #menuTrigger="matMenuTrigger"
    mat-icon-button
    st-click-stop-propagation
    st-space-stop-propagation
    st-enter-stop-propagation
    [disabled]="disabled()"
    [matMenuTriggerFor]="menu"
    (keydown.arrowdown)="onTriggerArrowDown()"
    (keydown.arrowup)="onTriggerArrowUp()"
    (menuOpened)="onMenuOpened()"
    (menuClosed)="onMenuClosed()">
    <mat-icon>add</mat-icon>
</button>

<mat-menu
    #menu="matMenu"
    class="st-assignment-creation-menu__panel"
    st-click-stop-propagation>
    <ng-template matMenuContent>
        <mat-selection-list
            #selectionList
            hideSingleSelectionIndicator
            (selectionChange)="onSelectionChange(selectionList)"
            (keydown.tab)="onTabKeydown($event)"
            (keydown.shift.tab)="onTabKeydown($event)">
            @for (item of types(); track item?.id) {
                <mat-list-option
                    st-click-stop-propagation
                    [dir]="dir()"
                    [value]="item.id">
                    <st-icon
                        matListItemIcon
                        [type]="item.id" />
                    <div matListItemTitle>{{ item.title }}</div>
                </mat-list-option>
            }
        </mat-selection-list>
    </ng-template>
</mat-menu>
